/* ============================================================
   PEGLAS — Pixel Animations & Interactions
   ============================================================ */

(function () {
  'use strict';

  /* ── 1. SCROLL REVEAL ──────────────────────────────────── */
  function initReveal() {
    var els = document.querySelectorAll('[data-pg-reveal]');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -60px 0px', threshold: 0.1 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ── 2. HERO PIXEL CANVAS ──────────────────────────────── */
  function initPixelCanvas() {
    var canvas = document.getElementById('pg-pixel-canvas');
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    var W, H, cols, rows, pixels = [], mouse = { x: -999, y: -999 };
    var SIZE = 24;
    var COLORS = ['#9B8FE8', '#F5A0B5', '#E8E0F5', '#FFE8F0', '#6B4FA0'];

    function resize() {
      W = canvas.offsetWidth;
      H = canvas.offsetHeight;
      canvas.width = W;
      canvas.height = H;
      cols = Math.ceil(W / SIZE);
      rows = Math.ceil(H / SIZE);
      pixels = [];
      for (var r = 0; r < rows; r++) {
        for (var c = 0; c < cols; c++) {
          pixels.push({
            x: c * SIZE, y: r * SIZE,
            alpha: Math.random() * 0.12,
            targetAlpha: Math.random() * 0.12,
            color: COLORS[Math.floor(Math.random() * COLORS.length)],
            speed: 0.008 + Math.random() * 0.012
          });
        }
      }
    }

    canvas.addEventListener('mousemove', function (e) {
      var rect = canvas.getBoundingClientRect();
      mouse.x = e.clientX - rect.left;
      mouse.y = e.clientY - rect.top;
    });
    canvas.addEventListener('mouseleave', function () {
      mouse.x = -999; mouse.y = -999;
    });

    var raf;
    function draw() {
      ctx.clearRect(0, 0, W, H);
      pixels.forEach(function (p) {
        var dx = mouse.x - (p.x + SIZE / 2);
        var dy = mouse.y - (p.y + SIZE / 2);
        var dist = Math.sqrt(dx * dx + dy * dy);
        var glow = dist < 100 ? (1 - dist / 100) * 0.5 : 0;

        if (Math.random() < 0.005) {
          p.targetAlpha = Math.random() * 0.15;
          p.color = COLORS[Math.floor(Math.random() * COLORS.length)];
        }
        p.alpha += (p.targetAlpha + glow - p.alpha) * p.speed;

        ctx.globalAlpha = Math.min(p.alpha, 0.6);
        ctx.fillStyle = p.color;
        ctx.fillRect(p.x, p.y, SIZE - 1, SIZE - 1);
      });
      ctx.globalAlpha = 1;
      raf = requestAnimationFrame(draw);
    }

    resize();
    window.addEventListener('resize', resize);
    draw();
  }

  /* ── 3. SCROLL PIXEL DISSOLVE ──────────────────────────── */
  function initScrollPixels() {
    var container = document.getElementById('pg-scroll-pixels');
    if (!container) return;
    var canvas = document.createElement('canvas');
    canvas.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:9999;opacity:0;transition:opacity 0.3s';
    document.body.appendChild(canvas);

    var ctx = canvas.getContext('2d');
    var particles = [];
    var lastScroll = window.scrollY;
    var timeout;
    var SIZE = 6;
    var COLORS = ['#9B8FE8', '#F5A0B5', '#6B4FA0', '#E8E0F5'];

    function resize() {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    }
    resize();
    window.addEventListener('resize', resize);

    function spawnParticles(count) {
      for (var i = 0; i < count; i++) {
        particles.push({
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height,
          vx: (Math.random() - 0.5) * 2,
          vy: -Math.random() * 3 - 1,
          size: SIZE * (0.5 + Math.random()),
          color: COLORS[Math.floor(Math.random() * COLORS.length)],
          life: 1.0,
          decay: 0.02 + Math.random() * 0.03
        });
      }
    }

    var active = false;
    function loop() {
      if (!active && particles.length === 0) return;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles = particles.filter(function (p) {
        p.x += p.vx;
        p.y += p.vy;
        p.vy += 0.05;
        p.life -= p.decay;
        if (p.life <= 0) return false;
        ctx.globalAlpha = p.life * 0.7;
        ctx.fillStyle = p.color;
        ctx.fillRect(Math.round(p.x), Math.round(p.y), Math.round(p.size), Math.round(p.size));
        return true;
      });
      ctx.globalAlpha = 1;
      requestAnimationFrame(loop);
    }

    window.addEventListener('scroll', function () {
      var delta = Math.abs(window.scrollY - lastScroll);
      lastScroll = window.scrollY;
      if (delta > 5) {
        canvas.style.opacity = '1';
        spawnParticles(Math.min(Math.floor(delta / 4), 15));
        if (!active) { active = true; loop(); }
        clearTimeout(timeout);
        timeout = setTimeout(function () {
          canvas.style.opacity = '0';
          active = false;
        }, 600);
      }
    }, { passive: true });
  }

  /* ── 4. CURSOR PIXEL TRAIL ─────────────────────────────── */
  function initCursorTrail() {
    if (window.matchMedia('(pointer: coarse)').matches) return;
    var canvas = document.createElement('canvas');
    canvas.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:9998';
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    var trail = [];
    var mouse = { x: 0, y: 0 };
    var COLORS = ['#9B8FE8', '#F5A0B5', '#6B4FA0'];

    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    window.addEventListener('resize', function () {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    });

    window.addEventListener('mousemove', function (e) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (Math.random() < 0.4) {
        trail.push({
          x: mouse.x + (Math.random() - 0.5) * 8,
          y: mouse.y + (Math.random() - 0.5) * 8,
          size: 3 + Math.random() * 3,
          color: COLORS[Math.floor(Math.random() * COLORS.length)],
          life: 1.0
        });
      }
    }, { passive: true });

    function loop() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      trail = trail.filter(function (p) {
        p.life -= 0.06;
        if (p.life <= 0) return false;
        ctx.globalAlpha = p.life * 0.5;
        ctx.fillStyle = p.color;
        ctx.fillRect(Math.round(p.x), Math.round(p.y), Math.round(p.size), Math.round(p.size));
        return true;
      });
      ctx.globalAlpha = 1;
      requestAnimationFrame(loop);
    }
    loop();
  }

  /* ── 5. MARQUEE PAUSE ON HOVER ─────────────────────────── */
  function initMarquee() {
    var marquees = document.querySelectorAll('.pg-marquee');
    marquees.forEach(function (m) {
      m.addEventListener('mouseenter', function () { m.style.animationPlayState = 'paused'; });
      m.addEventListener('mouseleave', function () { m.style.animationPlayState = 'running'; });
    });
  }

  /* ── 6. COLLECTION CARD TILT ───────────────────────────── */
  function initCardTilt() {
    if (window.matchMedia('(pointer: coarse)').matches) return;
    var cards = document.querySelectorAll('.pg-col-card, .pg-char-card');
    cards.forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        card.style.transform = 'translateY(-6px) rotateX(' + (-y * 6) + 'deg) rotateY(' + (x * 6) + 'deg)';
        card.style.transition = 'transform 0.1s ease';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
        card.style.transition = 'all 0.4s cubic-bezier(0.22, 1, 0.36, 1)';
      });
    });
  }

  /* ── INIT ───────────────────────────────────────────────── */
  function init() {
    initReveal();
    initPixelCanvas();
    initScrollPixels();
    initCursorTrail();
    initMarquee();
    initCardTilt();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init after Shopify section updates
  document.addEventListener('shopify:section:load', function () {
    setTimeout(init, 100);
  });

})();

  /* ── PIXEL TRAIL CURSOR ────────────────────────────────── */
  function initPixelTrail() {
    if (!window.matchMedia('(pointer: fine)').matches) return;

    var TRAIL = 14;
    var COLORS = [
      '#9B8FE8','#b8aeef','#F5A0B5','#f7bcc7','#E8E0F5',
      '#9B8FE8','#F5A0B5','#c4baf2','#faccda','#E8E0F5',
      '#9B8FE8','#F5A0B5','#d4cef5','#fdf8f5'
    ];
    var SIZES = [13,12,11,10,9,8,8,7,7,6,5,5,4,3];

    var dots = [];
    for (var i = 0; i < TRAIL; i++) {
      var el = document.createElement('div');
      var sz = SIZES[i];
      el.style.cssText = [
        'position:fixed',
        'width:' + sz + 'px',
        'height:' + sz + 'px',
        'background:' + COLORS[i],
        'border-radius:' + (i < 5 ? '3px' : '2px'),
        'pointer-events:none',
        'z-index:' + (99990 - i),
        'image-rendering:pixelated',
        'opacity:' + (1 - i * 0.055).toFixed(2),
        'transform:translate(-50%,-50%)',
        'will-change:left,top',
        'transition:none'
      ].join(';');
      document.body.appendChild(el);
      dots.push({ el: el, x: -200, y: -200 });
    }

    // Ring buffer for position history
    var hist = [];
    for (var j = 0; j < TRAIL + 4; j++) hist.push({ x: -200, y: -200 });
    var mx = -200, my = -200;

    document.addEventListener('mousemove', function(e) {
      mx = e.clientX; my = e.clientY;
    }, { passive: true });

    // Pixel-snap to 3px grid
    function snap(v) { return Math.round(v / 3) * 3; }

    function tick() {
      hist.unshift({ x: mx, y: my });
      hist.pop();
      for (var i = 0; i < TRAIL; i++) {
        var lag = Math.min(i + i, hist.length - 1);
        var p = hist[lag];
        dots[i].el.style.left = snap(p.x) + 'px';
        dots[i].el.style.top  = snap(p.y) + 'px';
      }
      requestAnimationFrame(tick);
    }
    tick();
  }

  /* ── INIT ALL ──────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function() {
    initPixelTrail();
  });

